import React from "react";
import "antd/dist/reset.css";
import "./styles/theme.css";
import IssuesDashboard from "./features/issues/IssuesDashboard";

function App() {
  return <IssuesDashboard />;
}

export default App;
